var map = {
	"./arrow-bottom.png": "e67b",
	"./arrow-up.png": "f3a8",
	"./bronce.png": "fb7f",
	"./bronce2.png": "9ae3",
	"./categories/1.png": "b935",
	"./categories/10.png": "7739",
	"./categories/11.png": "e4c8",
	"./categories/12.png": "6c27",
	"./categories/13.png": "15fc",
	"./categories/14.png": "cc4a",
	"./categories/15.png": "3e15",
	"./categories/16.png": "519c",
	"./categories/2.png": "43bd",
	"./categories/3.png": "e7bb",
	"./categories/4.png": "501a",
	"./categories/5.png": "42f9",
	"./categories/6.png": "80bb",
	"./categories/7.png": "e00c",
	"./header-rigth.png": "e800",
	"./inicial.png": "e20c",
	"./logo-header.svg": "c818",
	"./logo-header2.png": "dc73",
	"./logo-header3.png": "7ac0",
	"./logo.png": "cf05",
	"./logo1.jpg": "7c17",
	"./medal.png": "2ca9",
	"./notification.mp3": "e4c4",
	"./oro.png": "657a",
	"./oro2.png": "3477",
	"./plata.png": "5d07",
	"./plata2.png": "a09b",
	"./user.png": "c121"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";